module.exports = __webpack_public_path__ + "img/sh-icon-arrow-down.34015d80.svg";